// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  partyId: __t.u64().name("party_id"),
  offerId: __t.u64().name("offer_id"),
  state: __t.u8(),
  title: __t.string(),
  location: __t.string(),
  blob: __t.byteArray(),
  currentSite: __t.u16().name("current_site"),
  visited: __t.array(__t.u16()),
  cleared: __t.array(__t.u16()),
  cluesFound: __t.array(__t.u16()).name("clues_found"),
  encounterId: __t.option(__t.u64()).name("encounter_id"),
  encounters: __t.array(__t.u64()),
  startedAt: __t.timestamp().name("started_at"),
  settledAt: __t.option(__t.timestamp()).name("settled_at"),
  outcomeRow: __t.option(__t.u8()).name("outcome_row"),
  wipes: __t.u8(),
});
